import { z } from 'zod'

// `full` selects the unbounded history walk instead of the bounded trailing window. it defaults
// to false so a caller that merely opens the page gets the cheap incremental sync; only an
// explicit user action (the Sync button) asks for the whole history.
export const operationsSyncQuerySchema = z.object({
  full: z
    .union([z.boolean(), z.enum(['true', 'false'])])
    .transform((v) => v === true || v === 'true')
    .default(false),
})

export type OperationsSyncQueryDto = z.infer<typeof operationsSyncQuerySchema>
